export const notifications = {
	export: {
		successNotification: "Produtos exportados para Excel",
		errorNotification: "Erro ao exportar produtos para Excel",
	},
	productToggle: {
		successActivated: "O produto {{productName}} foi ativado com sucesso",
		successDeactivated: "O produto {{productName}} foi desativado com sucesso",
	},
	massActions: {
		successActivated: "Produtos ativados com sucesso",
		successDeactivated: "Produtos desativados com sucesso",
	},
	categoryNotFound:
		"Categoria não encontrada. Redirecionando para a primeira categoria disponível.",
};
